function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M15 29C22.732 29 29 22.732 29 15C29 7.26801 22.732 1 15 1C7.26801 1 1 7.26801 1 15C1 22.732 7.26801 29 15 29Z",
  stroke: "#020810",
  strokeWidth: 1.8
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M21.6603 19.251L15.9393 13.532C16.2233 12.7962 16.2853 11.9933 16.1177 11.2226C15.9501 10.452 15.5602 9.74736 14.9963 9.196C14.3957 8.6039 13.6292 8.20861 12.7986 8.06267C11.968 7.91674 11.1126 8.02707 10.3463 8.379L13.0463 11.079L11.1653 12.967L8.40026 10.267C8.03316 11.0302 7.91455 11.8893 8.0611 12.7234C8.20766 13.5575 8.612 14.3246 9.21726 14.917C9.76862 15.4809 10.4732 15.8708 11.2439 16.0384C12.0146 16.206 12.8175 16.144 13.5533 15.86L19.2723 21.579C19.329 21.6387 19.3972 21.6862 19.4728 21.7186C19.5485 21.7511 19.6299 21.7678 19.7123 21.7678C19.7946 21.7678 19.876 21.7511 19.9517 21.7186C20.0273 21.6862 20.0956 21.6387 20.1523 21.579L21.5973 20.134C21.6669 20.0858 21.7248 20.0226 21.7667 19.9491C21.8086 19.8755 21.8335 19.7935 21.8396 19.7091C21.8456 19.6247 21.8327 19.5399 21.8016 19.4612C21.7706 19.3824 21.7223 19.3116 21.6603 19.254V19.251Z",
  fill: "#020810"
});

var SvgSettingsBtnIcon = (_ref) => {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgSettingsBtnIcon, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/settings-btn-icon.e97d1a9a.svg";
export { ForwardRef as ReactComponent };